'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AxisLabels = require('../Utility/AxisLabels');

var _AxisLabels2 = _interopRequireDefault(_AxisLabels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MatrixChoiceLabels = function (_Component) {
  _inherits(MatrixChoiceLabels, _Component);

  function MatrixChoiceLabels() {
    _classCallCheck(this, MatrixChoiceLabels);

    return _possibleConstructorReturn(this, (MatrixChoiceLabels.__proto__ || Object.getPrototypeOf(MatrixChoiceLabels)).apply(this, arguments));
  }

  _createClass(MatrixChoiceLabels, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          questions = _props.questions,
          setRef = _props.setRef,
          className = _props.className;


      return _react2.default.createElement(
        'div',
        {
          ref: setRef,
          style: this.props.style,
          className: 'MatrixChoiceLabels-holder ' + className
        },
        questions.map(function (q, i) {
          var labels = void 0;
          if (q.display_type === 'slider') {
            labels = q.choices.labels;
            return _react2.default.createElement(_AxisLabels2.default, {
              key: i,
              max: q.choices.max,
              min: q.choices.min,
              step: q.choices.step,
              labels: labels,
              labelClass: 'MatrixChoiceLabel'
            });
          } else {
            labels = q.choices;
          }
          return _react2.default.createElement(
            'ul',
            { key: i, className: 'MatrixChoiceLabels-inner' },
            labels.map(function (c, i) {
              return _react2.default.createElement(
                'li',
                { key: i, className: 'MatrixChoiceLabel' },
                c.text
              );
            })
          );
        })
      );
    }
  }]);

  return MatrixChoiceLabels;
}(_react.Component);

exports.default = MatrixChoiceLabels;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Survey/MatrixChoiceLabels.js
// module id = 456
// module chunks = 0